<template>
  <!-- Coach Description -->
  <div class="mt-6 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
    <p class="text-sm text-gray-500 truncate mb-8">
          <span
              v-for="area in areas" :key="area"
              :class="`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-white mr-1 ${area}`">
                {{ area.toUpperCase() }}
            </span>
    </p>
    <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
      <div class="sm:col-span-1">
        <dt class="text-sm font-medium text-gray-500">
          Rate
        </dt>
        <dd class="mt-1 text-sm text-gray-900">
          $<strong>{{ rate }}</strong>/ hour
        </dd>
      </div>
      <div class="sm:col-span-2">
        <dt class="text-sm font-medium text-gray-500">
          About
        </dt>
        <dd class="mt-1 max-w-prose text-sm text-gray-900 space-y-5" v-html="description" />
      </div>
    </dl>
  </div>
</template>

<script>
export default {
  name: "CoachProfile",
  props: ['rate', 'description', 'areas'],
}
</script>

<style scoped>

</style>